import { Injectable, NgZone } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {

  constructor(
    private swUpdate: SwUpdate,
    private toastCtrl: ToastController,
    private ngZone: NgZone,
    private translate: TranslateService
  ) {
    this.init();
  }

  private init() {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        this.ngZone.run(() => {
          this.presentUpdateToast();
        });
      }
    });

    this.swUpdate.checkForUpdate();
  }

  private async presentUpdateToast() {
    const toast = await this.toastCtrl.create({
      message: this.translate.instant("NUOVA_VERSIONE_DISPONIBILE"),
      position: "bottom",
      duration: 0, // nessuna chiusura automatica
      buttons: [
        {
          text: this.translate.instant("AGGIORNA"),
          role: "reload",
          handler: () => {
            this.doUpdate();
          },
        },
        {
          text: this.translate.instant("ANNULLA"),
          role: "cancel",
        },
      ],
    });

    await toast.present();
  }

  private async doUpdate() {
    try {
      await this.swUpdate.activateUpdate();
    } catch (e) {
      // anche se fallisce, provo comunque a ricaricare
    }
    document.location.reload();
  }
}
